<div class="w-full max-w-xs mx-auto container mt-28" >
    <form class=" shadow-lg rounded px-8 pt-6 pb-8 mb-4" [formGroup]="fGroup" (ngSubmit)="doAddProject()">
        <div class="mb-4">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
                Project Name
            </label>
            <input class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none" id="email" type="email" formControlName="name" placeholder="Name" name="name" maxlength="50" ngModel required/>
        </div>

        <div class="mb-6">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
                link Image
                <a target="_blank" href="https://imagetolink.com/">convert your image to link</a>
            </label>
            <input class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="text" formControlName="imageLink" type="text" name="imageLink" ngModel required placeholder="https://"/>
        </div>

        <div class="mb-6">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
                Link Video
            </label>
            <input
            class="input appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="text" type="text" name="linkVideo" formControlName="linkVideo" ngModel required placeholder="http://youtube"/>
        </div>
        <div class="mb-6">
          <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
              Status
          </label>
          <div class="mb-3 xl:w-96">
            <select class="form-select appearance-none
              block
              w-full
              px-3
              py-1.5
              text-base
              font-normal
              text-gray-700
              bg-transparent bg-clip-padding bg-no-repeat
              border border-solid border-gray-300
              rounded
              transition
              ease-in-out
              m-0
              focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"
              formControlName="status"
              name="status"
              >
                <option selected>select status</option>
                <option value="Free">Free</option>
                <option value="Premium">Premium</option>
                <option value="IsComming">IsComming</option>
            </select>
          </div>
      </div>

        <div class="mb-6">
            <label class="block text-gray-700 text-sm font-bold mb-2" for="password">
                Projects Detail
            </label>

            <editor formControlName="description" type="text" name="description" ngModel required apikey="qky2vjlio14vfu0b5yeio3uich3pb4qcyospr9dwmzx2fzlu" selector="textarea" plugins="anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss" toolbar="undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight checklist numlist bullist indent outdent | emoticons charmap | removeformat"></editor>
        </div>

        <div *ngIf="isLoading" class="flex justify-center items-center">
            <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full" role="status">
              <!-- <span class="visually-hidden">Loading...</span> -->
            </div>
          </div>

        <div class="cursor-not-allowed flex items-center justify-between">
            <button class='cursor-not-allowed bg-blue-500  text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ' type="submit" [disabled]="fGroup.invalid">
                <span *ngIf="typeEdit == 'edit'">
                    Edit
                </span>
                <span *ngIf="typeEdit != 'edit'">
                    Save
                </span>
            </button>
            <button type="button" *ngIf="typeEdit == 'edit'" class='cursor-not-allowed bg-rose-500  text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ' (click)="doDeleteProject()">
              <span *ngIf="typeEdit == 'edit'">
                  Delete
              </span>
          </button>
          </div>


    </form>
    <p class="text-center text-gray-500 text-xs">&copy;2023 Angga</p>
</div>
